module.exports = __webpack_public_path__ + "fonts/rubik-medium-webfont.f59d0b28.f59d0b28.ttf";